import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as packageRateAction from '../../../../actions/packageRateAction';

import PackageRate from './PackageRate';

const mapStateToProps = state => {
    return {
        packageRateState: state.packageRateReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListPackageRates: (filters) => dispatch(packageRateAction.getListPackageRates(filters)),
        updatePackageRateActive: (id, data, filters) => dispatch(packageRateAction.updatePackageRateActive(id, data, filters)),
        deletePackageRate: (id, filters) => dispatch(packageRateAction.deletePackageRate(id, filters)),
        clonePackageRate: (id, filters) => dispatch(packageRateAction.clonePackageRate(id, filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PackageRate));
